<div class="chart-content">
  <h4 class="title">{{ title }}</h4>
  <canvas [id]="idChart"></canvas>
</div>


